import React from 'react';
import { Input } from './Input';

export const renderInput = ({
  input,
  placeholder,
  meta: { touched, error },
  defaultValue,
  handleChange,
  type,
  loading,
  disabled,
  maxLength,
  iconLeft,
  iconRight,
  autocomplete,
  isShouldError,
  className,
  isEditable
}) =>
(
  <Input
    {...input}
    type={type}
    name={input.name}
    placeholder={placeholder}
    handleChangeInput = {input.onChange}
    handleChange={handleChange}
    handleBlur={input.onBlur}
    maxLength={maxLength}
    error={touched && error || isShouldError}
    value={defaultValue}
    loading={loading}
    disabled={disabled}
    iconLeft={iconLeft}
    iconRight={iconRight}
    autocomplete={autocomplete}
    className={className}
    isEditable={isEditable}
  />
);
